import { ILoginResponse } from "app/services/default";
import { IAsyncState } from "app/core/redux";

// Action types
export enum UserActionTypes {
    GET_USER_DETAIL_REQUEST = "@user/GET_USER_DETAIL_REQUEST",
    GET_USER_DETAIL_SUCCESS = "@user/GET_USER_DETAIL_SUCCESS",
    GET_USER_DETAIL_FAILTURE = "@user/GET_USER_DETAIL_FAILTURE"
}

// Reducer state
export interface IUserState {
    user: IAsyncState<ILoginResponse>;
}
